import { render, staticRenderFns } from "./Aviso.vue?vue&type=template&id=221aa86d&scoped=true"
import script from "./Aviso.vue?vue&type=script&lang=js"
export * from "./Aviso.vue?vue&type=script&lang=js"
import style0 from "./Aviso.vue?vue&type=style&index=0&id=221aa86d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221aa86d",
  null
  
)

export default component.exports